import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetLineIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g fill="#444" transform="scale(0.0234375 0.0234375)"><path d="M150 788l-64-64 320-320 170 172 302-340 60 60-362 408-170-172z" /></g>
  </SvgIcon>;
};
